class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    this.varOptions = this.querySelector("select");
    
    if (!this.varOptions) {
      console.warn('Sticky variant select not found');
      return;
    }

    let productForms = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    
    if (!productForms) {
      console.warn('Product sticky form not found');
      return;
    }
    
    let input = productForms.querySelector('input[name="id"]');
    
    if (input) {
      input.value = this.varOptions.value;
    }
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

// Initialize sticky variant
let stickySelectedVariant = document.querySelector(`#sticky__variant`);
if (stickySelectedVariant) {
  let stickySelectVairantInput = document.querySelector(
    "#sticky__selected_variant_id"
  );
  if (stickySelectVairantInput) {
    stickySelectVairantInput.value = stickySelectedVariant.value;
  }
}

// Sticky cart scroll functionality
const BuyButtonForm = document.querySelector(".product_buy_button_form");
const productStickyWrapper = document.querySelector(".product__mt__sticky");

// Only add scroll listener if both elements exist
if (BuyButtonForm && productStickyWrapper) {
  window.addEventListener("scroll", function () {
    let BuyBUttonOffset = TopOffset(BuyButtonForm);
    let BuyBUttonTopffset = BuyBUttonOffset.top;

    if (window.scrollY > BuyBUttonTopffset) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  });
} else {
  // Log which elements are missing (helpful for debugging)
  if (!BuyButtonForm) {
    console.info('Sticky cart: Buy button form not found on this page');
  }
  if (!productStickyWrapper) {
    console.info('Sticky cart: Product sticky wrapper not found on this page');
  }
}